export const settingsSubscribers = new Set();

export const openTournamentSettings = (tab) => {
    settingsSubscribers.forEach(cb => cb(tab));
};

// "groups"/"brackets"/"draws" tournament tabs all map to the one merged
// "draw-stages" settings tab (see TournamentSettingsModal.js) - it replaced
// the separate Groups/Brackets settings screens. Shared by Header.js's
// bottom-nav Settings link and TournamentMenu.js's "..." dropdown Settings
// item, both of which open settings generically for "whatever tab is
// currently active" rather than already knowing their own settings tab the
// way a tab component calling openTournamentSettings directly does.
export const getSettingsTabForTab = (activeTab) => {
    if (activeTab === "information") return null;
    if (activeTab === "groups" || activeTab === "brackets" || activeTab === "draws") return "draw-stages";
    return activeTab;
};
